// extracted by mini-css-extract-plugin
module.exports = {"tableBodyColumn":"styles_tableBodyColumn__1494c"};